<template>
  <form
    class="flex w-full h-full"
    @submit.prevent="$emit('submit')"
  >
    <button
      type="button"
      class="px-5"
      style="color: #B2B2B2;"
      @click="$emit('close')"
    >
      <i class="fa fa-times" />
    </button>

    <label class="w-full h-full">
      <span class="sr-only">
        Search the marketplace
      </span>

      <input
        ref="input"
        v-model="query"
        type="text"
        placeholder="Search the marketplace"
        class="h-full w-full bg-transparent text-white"
      >
    </label>

    <button
      class="px-5"
      style="color: #B2B2B2;"
      :type="searching ? 'button' : 'submit'"
    >
      <i
        :class="searching ? 'fad fa-spinner-third fa-spin' : 'fa fa-search'"
      />
    </button>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => '',
    },

    searching: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    query: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
